import { render, staticRenderFns } from "./ProjectDetailCard.vue?vue&type=template&id=2ad2ac46&scoped=true"
import script from "./ProjectDetailCard.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetailCard.vue?vue&type=style&index=0&id=2ad2ac46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2ac46",
  null
  
)

export default component.exports